<template>

  <div>

    <el-row v-if="siteSelect" :gutter="gutter">
      <el-col :span="24">

        <el-alert
          type="warning"
          title="Site Required"
          description="Please select a site to successfully save this provider."
          show-icon>

        </el-alert>
        <select-site v-model="form.site_id" no-form :disabled="disabled" />
      </el-col>
    </el-row>


    <el-row v-if="!localNew  && this.form.active  && this.form.active.length > 0">

      <h4>Active Customers</h4>

      <table class="el-table">
        <thead>
          <tr>
            <th>#</th>
            <th v-if="isTowerCo()">Cust. Status</th>
            <th>Customer</th>
            <th>Provider</th>
            <th>Prov. Status</th>
            <th>Type</th>
            <th v-if="canAccess('finance')" class="hidden-md-and-down" align="right">Entrance Fee</th>
            <th v-if="canAccess('finance')" class="hidden-md-and-down" align="right">ROW Fee</th>
            <th class="hidden-md-and-down">Serivce Starts</th>
            <th v-if="canAccess('finance')">Expiry</th>
          </tr>
        </thead>
        <tfoot>
        </tfoot>
        <tbody>
          <tr v-for="(bh, index) in form.active" :key="index">
            <td>{{index+1}}</td>
            <td v-if="isTowerCo()">{{bh.status}}</td>
            <td v-if="isTowerCo()">{{bh.organisation.name}}</td><td v-else><b>{{form.active.length}}</b></td>
            <td>{{form.providerShortName}}</td>
            <td>{{form.status}}</td>
            <td>{{form.backhaulType}}</td>
            <td v-if="canAccess('finance')" class="hidden-md-and-down">{{formatNumber(bh.depositFee)}}</td>
            <td v-if="canAccess('finance')" class="hidden-md-and-down">{{formatNumber(bh.rightOfWayCharges)}}</td>
            <td class="hidden-md-and-down">{{formatDate(bh.startService)}}</td>
            <td v-if="canAccess('finance')">{{formatDate(bh.expiry)}}</td>
          </tr>
        </tbody>
      </table>
      <br>
    </el-row>


    <edit-pane v-if="isManager('project|maintenance|finance|admin')" ref="bh" title="Backhaul Provider"
      :editable="canAccess('project|finance|admin|management') && isTowerCo()"
      :is-edit="editMode"
      @save="onSave"
      @cancel="onCancel"
      @edit="onEdit"
      @add="onSave">

      <div class="padded">

        <el-form  :label-position="this.isDesktop || this.isTablet ? 'top' : 'left'" label-width="134px">

          <el-row :gutter="gutter">

            <el-col :sm="mq.sm" :md="mq.md" :lg="mq.lg">
              <select-backhaul-status v-model="form.status" @change="resetDates" :disabled="(disabled && isTowerCo()) || lockedForViewer" />
            </el-col>

            <el-col v-if="localNew" class="bg-primary-lighten-1" style="border-radius: 8px" :sm="mq.sm" :md="mq.md" :lg="mq.lg">
              <date-input v-model="form.startService" label="Serivce Start" placeholder="Started" :disabled="disabled" />
            </el-col>

            <el-col v-if="form.status === 'Terminated'" class="bg-danger-lighten-2" style="border-radius: 8px" :sm="mq.sm" :md="mq.md" :lg="mq.lg">
              <date-input v-model="form.terminateService"
              label="Terminated"
              placeholder="Terminated"
              :disabled="(disabled && isTowerCo()) || lockedForViewer" />
            </el-col>


            <el-col :sm="mq.sm" :md="mq.md" :lg="mq.lg">
              <select-backhaul-provider v-if="!providerId" v-model="form.provider_id" :disabled="disabled" />
            </el-col>

            <el-col :sm="mq.sm" :md="mq.md" :lg="mq.lg">
              <select-backhaul-type label="Backhaul Type" v-model="form.backhaulType" :disabled="disabled" />
            </el-col>

            <el-col :sm="mq.sm" :md="mq.md" :lg="mq.lg">
              <text-input label="LRD Provider" v-model="form.lrdProvider" :disabled="disabled" />
            </el-col>

          </el-row>


          <el-row :gutter="gutter">
            <el-col :md="8">
              <switch-input v-model="form.exclusive"
                :label="(form.providerShortName ? form.providerShortName : 'Provider') + ' Exclusive'"
                :disabled="(disabled && isTowerCo()) || lockedForViewer" />
            </el-col>

            <el-col :md="8">
              <switch-input v-model="form.deposit"
               label="Entrance"
               :disabled="(disabled && isTowerCo()) || lockedForViewer" />
            </el-col>

            <el-col :md="8">
              <switch-input v-model="form.rightOfWay"
                label="Right of Way"
                :disabled="(disabled && isTowerCo()) || lockedForViewer" />
            </el-col>

          </el-row>

          <el-collapse v-if="isTowerCo()" v-model="section" accordion>

            <!-- Contact Section -->
            <el-collapse-item name="1">
              <template #title>
                <span class="text-primary"><i><b>Contract</b></i> <span v-if="form.started">: <b>{{formatNumber(form.tenor, 0)}}</b> yr. from <b>{{formatDate(form.started)}}</b> to <b>{{formatDate(form.expiry)}}</b></span></span>
              </template>

              <el-row class="padded" :gutter="gutter">

                <el-col :sm="24" :md="9">
                  <text-input placeholder="Contract No" v-model="form.contractNo" :disabled="disabled" />
                </el-col>

                <el-col :sm="24" :md="12" :lg="6">
                  <date-input v-model="form.started" placeholder="Started" :disabled="disabled" />
                </el-col>

                <el-col :sm="20" :md="9" :offset="1">
                  <el-form-item placeholder="Tenor">
                    <el-slider
                    v-model="tenor" :min="1" :max="24" :step="1" show-stops :show-input="!localNew"  :disabled="disabled">
                  </el-slider>
                </el-form-item>
              </el-col>


              <el-col :sm="24" :md="12" :lg="6">
                <el-form-item>
                  <b>{{formatFriendlyDate(form.expiry)}}</b> ({{formatDate(form.expiry)}})
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>



          <!-- Exclusive Section -->
          <el-collapse-item v-if="form.exclusive && canAccess('finance')" name="2">
            <template #title>
              <span class="text-primary"><i><b>Exclusivity</b></i> <span v-if="form.exclusiveExpiry">: expires on <b>{{formatDate(form.exclusiveExpiry)}}</b></span></span>
            </template>

            <el-row class="padded" :gutter="gutter">

              <el-col :md="6">
                <number-input label="Fee"  v-model="form.exclusiveFee" placeholder="Fee" :disabled="disabled" />
              </el-col>

              <el-col :md="6" :offset="2">
                <date-input v-model="form.exclusiveExpiry" label="Expiry" placeholder="Expiry" :disabled="disabled" />
              </el-col>

              <el-col :md="6" :offset="2">
                <select-frequency  v-model="form.exclusiveFrequency" label="Frequency" placeholder="Frequency" :disabled="disabled" />
              </el-col>

            </el-row>
          </el-collapse-item>


          <!-- Entrance Section -->
          <el-collapse-item  v-if="form.deposit && canAccess('finance')" name="3">
            <template #title>
              <span class="text-primary"><i><b>Deposit / Entrance</b></i> <span v-if="form.depositPaid">: paid on <b>{{formatDate(form.depositPaid)}}</b></span></span>
            </template>
            <el-row  class="padded" :gutter="gutter">
              <el-col :span="6">
                <float-input label="Entrance Fee"  v-model="form.depositFee"  placeholder="Fee" :disabled="disabled" />
              </el-col>

              <el-col :span="12">
                <date-input v-model="form.depositPaid" label="Date Paid" placeholder="Date Paid" :disabled="disabled" />
              </el-col>

              <el-col :span="6">
                <text-input  v-model="form.depositRef" label="Ref" placeholder="Ref" :disabled="disabled" />
              </el-col>
            </el-row>
          </el-collapse-item>


          <!-- Right of Way Section -->
          <el-collapse-item v-if="form.rightOfWay && canAccess('finance')" name="4">
            <template #title>
              <span class="text-primary"><i><b>Right of Way</b></i><!-- <span v-if="form.startService">: from <b>{{formatDate(form.startService)}}</b> to <b>{{formatDate(form.terminateService)}}</b></span> --></span>
            </template>
            <el-row class="padded" :gutter="gutter">
              <el-col :md="6">
                <float-input v-model="form.rightOfWayCharges" label="Right of Way" placeholder="ROW Charges" :disabled="disabled" />
              </el-col>

              <el-col :md="6" :offset="2">
                <float-input  v-model="form.exclusiveFee" label="Exclusive Fee" placeholder="Exclusive Fee" :disabled="disabled" />
              </el-col>

            </el-row>
          </el-collapse-item>


          <!-- Service Section -->
          <el-collapse-item name="5" v-if="!localNew">
            <template #title>
              <span class="text-primary"><i><b>Serivce</b></i> <span v-if="form.startService">: from <b>{{formatDate(form.startService)}}</b><span v-if="form.terminateService"> to <b class="text-danger">{{formatDate(form.terminateService)}}</b></span></span></span>
            </template>
            <el-row class="padded" :gutter="gutter">
              <el-col :md="6">
                <date-input v-model="form.startService" label="Serivce Start" placeholder="Started" :disabled="disabled" />
              </el-col>

              <el-col :md="6" :offset="2">
                <date-input v-model="form.terminateService"
                label="Terminated"
                placeholder="Terminated"
                :disabled="!editMode && (this.form.status =='Active')" />
              </el-col>
            </el-row>
          </el-collapse-item>


          <!-- Other Fees Section -->
          <el-collapse-item v-if="canAccess('finance')" name="6">
            <template #title>
              <span class="text-primary"><i><b>Sundry &amp; Other Fees</b></i><!-- <span v-if="form.startService">: from <b>{{formatDate(form.startService)}}</b> to <b>{{formatDate(form.terminateService)}}</b></span> --></span>
            </template>

            <el-row class="padded" :gutter="gutter">
              <el-col :md="6">
                <float-input label="Recurring Fee" v-model="form.recurringFee" placeholder="Sundry Fees" :disabled="disabled" />
              </el-col>

              <el-col :md="6" :offset="2">
                <select-frequency v-model="form.frequency" label="Frequency" :disabled="disabled" />
              </el-col>
          </el-row>

          </el-collapse-item>

        </el-collapse>

    </el-form>

    <el-row v-if="this.form.others && this.form.others.length > 0" :gutter="gutter">
      <hr />
      <h4>Other Customers</h4>
      <table class="el-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Status</th>
            <th>Customer</th>
            <th>Provider</th>
            <th align="right">Entrance Fee</th>
            <th align="right">ROW Fee</th>
            <th>Started</th>
            <th>Expiry</th>
          </tr>
        </thead>
        <tfoot>
        </tfoot>
        <tbody>
          <tr v-for="(bh, index) in form.others" :key="index">
            <th>{{index+1}}</th>
            <td>{{bh.status}}</td>
            <td>{{bh.organisation.name}}</td>
            <td>{{form.providerShortName}}</td>
            <td>{{formatNumber(bh.entranceFee)}}</td>
            <td>{{formatNumber(bh.rowFee)}}</td>
            <td>{{formatDate(bh.started)}}</td>
            <td>{{formatFriendlyDate(bh.expiry)}}</td>
          </tr>
        </tbody>
      </table>
      <br>
    </el-row>

  </div>

</edit-pane>

<div v-if="form.updated_at" class="pull-right">
  <span class="pull-right">Last update: <b>{{formatFriendlyDate(form.updated_at)}}</b> ({{formatDateTime(form.updated_at)}})<span v-if="form.updated_by"> by {{form.updated_by}}</span></span>
</div>

</div>

</template>


<script>


import SiteMixins from '@/mixins/SiteMixins'

import SelectBackhaulType from '@/components/atoms/selects/SelectBackhaulType'
import SelectBackhaulStatus from '@/components/atoms/selects/SelectBackhaulStatus'
import SelectBackhaulProvider from '@/components/atoms/selects/SelectBackhaulProvider'

import SelectSite from '@/components/atoms/selects/SelectSite'


export default {

  mixins: [SiteMixins],

  components: {
    SelectBackhaulType,
    SelectBackhaulStatus,
    SelectBackhaulProvider,
    SelectSite
  },


  props: {

    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },

    recordId: {
      type: Number,
      default: null
    },

    siteId: {
      type: Number,
      default: null
    },

    sharerId: {
      type: Number,
      default: null
    },

    providerId: {
      type: Number,
      default: null
    },

    actionId: {
      type: Number,
      default: null
    },

    editable: {
      type: Boolean,
      default: false
    },

    showEditButton: {
      type: Boolean,
      default: true
    },

    isNew: {
      type: Boolean,
      default: false
    },

    isRequest: {
      type: Boolean,
      default: false
    },

    tableRef: {
      type: String,
      default: 'backhaultable'
    },

    // XOL-552: "+ Backhaul" at RTB step 3 pre-fills the form (Provider = the
    // telco's Backhaul twin, Type = the RTB's type). These are DEFAULTS on the
    // new form, not `providerId`: passing providerId would hide the provider
    // picker, and here the provider must stay editable.
    defaultProviderId: {
      type: Number,
      default: null
    },

    defaultBackhaulType: {
      type: String,
      default: null
    }

  },



  computed: {
    // XOL-526 (C4): a non-Tower-Co viewer of a Request must never land in
    // edit mode here, regardless of what `editable` the caller passes — step3
    // now passes `editable: isTowerCo() || isRequestProvider()`, which would
    // otherwise put a provider straight into the edit form for a save
    // (`PUT /backhaul`) that has no Telco/Backhaul ACL row at all.
    lockedForViewer () {
      return this.isRequest && !this.isTowerCo()
    }
  },

  methods: {

    // XOL-552: the blank form for a new line. Called from data() (methods are
    // initialised before data() in Vue 2), because SelectBackhaulProvider copies
    // its `value` once at creation and has no watcher — a default that lands
    // after the select exists would never show.
    newLineForm () {
      var f = this.getTableStruct('backhaul')

      // Same stamp getBackhaul's new branch applies for an RTB.
      if (this.actionId) {
        f.action_id = this.actionId
        f.status = 'Pending'
      }

      if (this.defaultProviderId) { f.provider_id = this.defaultProviderId }
      if (this.defaultBackhaulType) { f.backhaulType = this.defaultBackhaulType }

      return f
    },

    getBackhaul (data) {

      if (data && data[0]) {
        this.localNew = false
        this.form = data[0]

      } else {
        this.localNew = true
        this.form = this.getTableStruct('backhaul')
        this.form.status = 'Pending'
        this.form.site_id = this.siteId
        this.form.organisation_id = this.sharerId
        this.form.action_id = this.actionId
      }

    },


    onCancel () {
      this.disabled = true
    },

    onEdit () {
      this.disabled = false
    },

    onAdd (func) {
      this.disabled = false
      this.onSave(func)
    },

    onSave () {
      this.form.started = this.formatDateSql(this.form.started)
      this.form.expiry = this.formatDateSql(this.form.expiry)

      this.form.exclusiveExpiry = this.formatDateSql(this.form.exclusiveExpiry)
      this.form.depositPaid = this.formatDateSql(this.form.depositPaid)

      this.form.startService = this.formatDateSql(this.form.startService)
      this.form.terminateService = this.formatDateSql(this.form.terminateService)

      if (!this.form.action_id && this.actionId) {
        this.form.action_id = this.actionId
      }

      this.saveForm(this, '/backhaul', this.form.id, this.form, this.form.backhaulType, this.onClose)
      this.disabled = true
    },

    onClose (data) {

      // XOL-552: tell the parent the line was saved. It only runs after a 200
      // (saveForm's success callback), never on a 422.
      this.$emit('saved', data)

      if (this.tableRef && !this.isRequest) {
        this.$events.emit(this.tableRef + '-refresh-table')
      }

    },

    resetDates (value) {
      if (value !== 'Terminated') {
        this.form.terminateService = null
      }
    }

  },



  watch: {

    form: function (data) {
      this.form = data
    },

    providerId: function (value) {
      // XOL-552: a null/undefined prop update must not blank the provider
      // (mirrors the BackhaulCustomer guard from XOL-553).
      if (value !== null && value !== undefined) {
        this.form.provider_id = value
      }
    },

    tenor: function (value) {
      if (this.form) {
        this.form.expiry = this.contractExpiryDate(this.form.started, Number(this.tenor), 'years', 'YYYY-MM-DD')
        this.form.tenor = Number(value)
      }
    }

  },



  data () {

    return {
      localSiteId: (this.siteId || this.rowData.site_id),
      siteSelect: (this.isNew ? true : (!this.rowData.site_id || !this.siteId)),
      localNew: this.isNew,
      gutter: 32,
      mqAdd: {sm: 24, md: 24, lg: 12},
      mq: {sm: 24, md: 12, lg: 6},
      section: '1',
      disabled: !this.isNew,
      // XOL-526 (C4): the computed `lockedForViewer` isn't initialised yet
      // when data() runs (Vue's initState order is props → methods → data →
      // computed), so the SAME rule is repeated inline here rather than read
      // from it. `mounted()`/the template use the computed once it exists.
      editMode: ((this.editable || this.isRequest) || this.isNew) && !(this.isRequest && !this.isTowerCo()),
      form: (this.isNew ? this.newLineForm() : this.rowData),
      tenor: 1
    }

  },



  mounted () {

    if (this.isRequest && this.editable) {
      this.localNew = (this.siteId && this.sharerId) ? true : false
      // XOL-526 (C4): was unconditionally `true` / `false` — a non-Tower-Co
      // caller (a provider, once step3 passes it `editable=true`) must never
      // land in an editable form here.
      this.editMode = !this.lockedForViewer
      this.disabled = this.lockedForViewer

      if (this.siteId && this.sharerId) {

        this.fetchData('backhaul/site/' + this.siteId + '/org/' + this.sharerId,
        this.getBackhaul,
        'Backhaul Provider')

      } else {

        if (this.providerId) {
          this.fetchData('backhaul/' + this.siteId + '/' + this.providerId,
          this.getBackhaul,
          'Backhaul Provider')
        }

      }

    }

    this.tenor = this.form.tenor ? Number(this.form.tenor) : 1

    this.siteSelect = !this.localSiteId

    if (this.localNew) {
      this.mq = this.mqAdd

      this.form.site_id = this.localSiteId

      if (this.sharerId) {
        this.form.organisation_id = this.sharerId
        this.siteSelect = false
      } else {
        delete this.form.organisation_id
        delete this.form.organisation
      }

      if (this.providerId) {
        this.form.provider_id = this.providerId
      } else if (!this.defaultProviderId) {
        // XOL-552: keep a pre-filled default; only blank the provider when
        // there is none (Site -> Backhaul "+ Provider").
        delete this.form.provider_id
        delete this.form.provider
      }

    }

  }
}

</script>
